<template>
  <span>
    <el-button type="primary" @click="$refs.upload.click()">本地视频</el-button>&nbsp;&nbsp;&nbsp;
    <input
      type="file"
      accept="video/*"
      ref="upload"
      :multiple="multiple"
      @change="emitSelect($event.target.files); $event.target.value=null;"
      style="display:none;"
    >
    <!-- <el-button type="primary" @click="presetVisible = true">使用预置视频</el-button>
    <el-dialog :visible.sync="presetVisible" title="选择预置视频" @close="videos.forEach(e => e.active = false)" append-to-body>
      <div style="display: flex;flex-direction: column;align-items: center;">
        <div v-for="e of videos" :key="e">
          <video
            ref="preset"
            :key="e.src"
            controls 
            width="100%" 
            type="video/mp4"
            :src="e.src"
            @click="presetSelect(e)"
            >
          </video>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="presetVisible = false">取 消</el-button>
        <el-button @click="presetConfirm">确 定</el-button>
      </span>
    </el-dialog> -->
  </span>
</template>
<script>
import hh from "../assets/videos/hh.mp4";
import xx from "../assets/videos/xx.mp4";

export default {
  props: {
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      presetVisible: false,
      videos: [
        { src: hh, mimeType: "video/mp4", name: "hh.mp4", active: false },
        { src: xx, mimeType: "video/mp4", name: "xx.mp4", active: false }
      ]
    };
  },
  methods: {
    emitSelect(files) {
      window.console.log("bbb " + files.length);
      if (files.length === 0) {
        return;
      }

      this.$emit("select", [...files]);
    },

    presetSelect(video) {
      video.active = !video.active;
      if (!this.multiple) {
        this.videos.filter(e => e !== video).forEach(e => (e.active = false));
      }
    },

    presetConfirm() {
      for (let i = 0; i < this.videos.length; i++) {
        if (!this.videos[i].active) {
          continue;
        }
        window.console.log("bbb1 " +  this.videos[i].src)
        var video = new File([this.videos[i].key], this.videos[i].src, {type:'video/mp4',});
        window.console.log("video.name " +  video.name);
        window.console.log("video.size " +  video.size);
        // this.$emit("update", { file: video});
        this.$emit("update", { file: this.videos[i]});
      }
      
      this.presetVisible = false;
    }
  }
};
</script>
<style scoped>
img.active {
  border: 2px red solid;
}
</style>

